import * as React from "react";
import { MetricType } from "../model/metricType";
import { MetricSelectorItem } from "./metricSelectorItem";

interface MetricSelectorProps {
    selectedMetricType: MetricType;
    onSelectedMetricTypeChanged: (metricType: MetricType) => void;
}

export class MetricSelector extends React.Component<MetricSelectorProps, {}> {
    constructor(props: MetricSelectorProps) {
        super(props);
        this.onItemSelected = this.onItemSelected.bind(this);
    }

    render(): JSX.Element {
        return <div className="vbox  right-aligned" style={{marginRight: "10px"}}>
            { MetricType.AllTypes.map(metricType =>
                <MetricSelectorItem key={metricType.name}
                                    metricType={metricType}
                                    selected={this.props.selectedMetricType == metricType}
                                    onSelected={this.onItemSelected}/>) }
        </div>;
    }

    private onItemSelected(metricType: MetricType) {
        this.props.onSelectedMetricTypeChanged(metricType);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/metricSelector.tsx